export default function getHomePath(user,licenses) {
  
  const { role, school, schoolDistrict } = user
  let homePath
  const paths = {
    'Super Administrator': '/users/manage/districts',
    'District Admin': `/users/manage/schools/${schoolDistrict}`,
    'School Admin': `/users/manage/teachers/${school}`,
  }
  if (paths[role]) {
    homePath = paths[role]
  } else {
    let licenseSet = !!licenses.find((o)=> o.licenseSet === '6e60eb20-172e-11e8-8bfb-cb0010808928') ? '6e60eb20-172e-11e8-8bfb-cb0010808928' :  '1086b940-233e-11e9-8f3e-41b7d45042fb'
    if (role === 'Teacher') {
      homePath = `/assessment/dashboard/${licenseSet}?gua=${user.id}`
    } else if (role === 'Student') {
      homePath = `/assessment/dashboard/${licenseSet}`
    }
  }
  return homePath
}


// WEBPACK FOOTER //
// ./src/helpers/users/getHomePath.js